import { render } from "./RealizarAssinaturaDeclaracao.vue?vue&type=template&id=4c983138&scoped=true"
import script from "./RealizarAssinaturaDeclaracao.vue?vue&type=script&lang=js"
export * from "./RealizarAssinaturaDeclaracao.vue?vue&type=script&lang=js"

import "./RealizarAssinaturaDeclaracao.vue?vue&type=style&index=0&id=4c983138&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c983138"]])

export default __exports__